<header nx-header [class.non-prod]="isNonProdEnvironment">
  <nx-header-brand class="nx-margin-right-5xl">
    <nx-link>
      <a href="#">
        <figure nxFigure>
          <img
               src="assets/Allianz_Logo.png"
               alt="Brand Logo"
               style="height: 32px" />
        </figure>
      </a>
    </nx-link>

    <nx-header-app-title>Incident Portal</nx-header-app-title>
  </nx-header-brand>

  <nav class="nx-margin-left-auto nx-margin-right-m">

    <nx-link>
      <a routerLink="/service-config">Service Config</a>
    </nx-link>

    <nx-link class="nx-margin-left-m">
      <a routerLink="/incident-communications">Incident Communications</a>
    </nx-link>

    @if (isLocalEnvironment) {
    <nx-link class="nx-margin-left-m">
      <a routerLink="/communications-form">Manual Form</a>
    </nx-link>
    }

  </nav>

  <nx-header-actions>
    @if (isNonProdEnvironment) {
    <span class="env-section">
      <pre class="env nx-font-weight-light">Environment: </pre>
      <p>{{ currentEnvironment | uppercase }}</p>
    </span>
    }
    <app-accessibility></app-accessibility>
  </nx-header-actions>
</header>